'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('./constants.js');

var _CONSUMER, _PROVIDER;
var transactionStatusFormatted = {
  CONSUMER: (_CONSUMER = {}, _CONSUMER[constants.TRANSACTION_STATUSES.COMPLETED] = 'Paid', _CONSUMER[constants.TRANSACTION_STATUSES.CANCELLED] = 'Cancelled', _CONSUMER[constants.TRANSACTION_STATUSES.PENDING] = 'Requested', _CONSUMER[constants.TRANSACTION_STATUSES.ERRORED] = 'Error', _CONSUMER[constants.TRANSACTION_STATUSES.REFUNDED] = 'Refunded', _CONSUMER[constants.TRANSACTION_STATUSES.PARTIALLY_REFUNDED] = 'Paid', _CONSUMER),
  PROVIDER: (_PROVIDER = {}, _PROVIDER[constants.TRANSACTION_STATUSES.PARTIALLY_REFUNDED] = 'Partial refund', _PROVIDER[constants.TRANSACTION_STATUSES.UNDER_REVIEW] = 'Under review', _PROVIDER[constants.TRANSACTION_STATUSES.ERRORED] = 'Errored', _PROVIDER)
};

exports["default"] = transactionStatusFormatted;
